/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	
	/**
	 * Created by tford on 5/25/16.
	 */
	
	/*
	 * Friend Request Modal
	 * Used just after a user has unblocked someone.
	 * Allows user to send friend request or wait.
	 */
	
	define('fitbit-jquery-friendRequestModal',['require'],function(require) {
	
	    // Prevent duplicate initialization
	    if ($.isFunction($.fn.friendRequestModal)) {
	        return;
	    }
	
	    /*
	     * jQuery plugin
	     */
	    $.fn.friendRequestModal = function(options) {
	        var $self = $(this),
	            $modalContent = $self.find('#friendRequestContent'),
	            $successMessage = $self.find('#friendRequestSuccess'),
	            $errorMessage = $self.find('#friendRequestError'),
	            bindEvents = function() {
	                $self.find(".friend-request-controls .send").click(function(e) {
	                    e.stopPropagation(); // Don't propagate to e.g. notification dropdown.
	                    if (options.callback && typeof options.callback == 'function') {
	                        if (options.closeBeforeCallback) {
	                            $self.data("overlay").close();
	                        }
	                        options.callback();
	                    }
	                });
	                $self.find(".friend-request-controls .cancel").click(function(e) {
	                    e.stopPropagation(); // Don't propagate to e.g. notification dropdown.
	                    $self.data("overlay").close();
	                });
	                $('#blocking-mask').click(function(e) {
	                    e.stopPropagation();
	                    $self.data("overlay").close();
	                });
	            },
	            unbindEvents = function() { 
	                $self.find(".friend-request-controls .send").unbind('click');
	                $('#blocking-mask').unbind('click');
	            },
	            handleClose = function() {
	                unbindEvents();
	                $self.data("overlay", null);
	            },
	            addData = function() {
	                if (options.userName) {
	                    $self.find('.name').text(options.userName);
	                }
	            };
	
	        addData();
	
	        $self.overlay({
	            mask: {
	                maskId: 'blocking-mask',
	                color: "#000",
	                zIndex: 199998,
	                closeOnClick: false
	            },
	            onClose: function() {
	                setTimeout(handleClose, 0); // Required to let overlay's mask fully close.
	            }
	        });
	        $self.data("overlay").load();
	        $successMessage.hide();
	        $errorMessage.hide();
	        $modalContent.show();
	        bindEvents();
	    };
	}); // End define block.
	;}.call(window));

/***/ }
/******/ ])


/** WEBPACK FOOTER **
 ** friendRequestModal.js.9b255bc8795aaa9a5d902304b547bfa4.js
 **/